import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { useLocation, useNavigationType } from "react-router-dom";
import { Box } from "@mui/material";

const HeaderFooterWrapper = ({ children }) => {
  const location = useLocation();
  const navigationType = useNavigationType();

  const [showLoading, setShowLoading] = useState(false);
  const [forceLoading, setForceLoading] = useState(true);
  const [sectionPositions, setSectionPositions] = useState([]);
  const [scrollTarget, setScrollTarget] = useState(null);
  const innerMargin = "0.05";
  const maxWidth = 1280;
  const innerWidth = window.innerWidth;

  let blankMargin = 0;
  let sumMargin = 0;
  let pageWidthCalc = 0;
  let newMaxWidth = 0;

  if (innerWidth > maxWidth) {
    newMaxWidth = maxWidth;
    blankMargin = (innerWidth - newMaxWidth) / 2;
    sumMargin = 2 * innerMargin * newMaxWidth;
    pageWidthCalc = newMaxWidth - sumMargin;
  } else {
    newMaxWidth = innerWidth;
    blankMargin = 0;
    sumMargin = 2 * innerMargin * innerWidth;
    pageWidthCalc = innerWidth - sumMargin;
  }
  const headerPosition = blankMargin + sumMargin / 2;

  // ✅ On first mount, store the scroll target from location.state
  const scrollIntent = location.state?.scrollToSection;
  useEffect(() => {
    if (scrollIntent) {
      setScrollTarget(scrollIntent.toLowerCase());
      window.history.replaceState(null, "", window.location.pathname); // Clean URL
    }
  }, [scrollIntent]);

  // ✅ Once sectionPositions are available, scroll to the target
  useEffect(() => {
    if (!scrollTarget || sectionPositions.length === 0) return;

    const match = sectionPositions.find(
      (s) =>
        s.text?.toLowerCase().replace(/\s+/g, "") ===
        scrollTarget.replace(/\s+/g, "")
    );

    if (match) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: match.top, behavior: "smooth" });
      });
      setScrollTarget(null); // prevent repeat scroll
    }
  }, [scrollTarget, sectionPositions]);

  const footerData = {
    is_visible: true,
    background_color: "FF0000",
    is_sticky: false,
    is_transparent: false,
    opacity: "1",
    is_border: false,
    border: 1,
    border_color: "FF00FF",
    height: [
      {
        screen_type_id: "01",
        height: "0.4",
      },
      {
        screen_type_id: "02",
        height: "0.5",
      },
    ],
    width: [
      {
        screen_type_id: "01",
        width: "1",
      },
    ],
  };
  const headerData = {
    is_visible: true,
    background_color: "FF0000",
    is_sticky: true,
    is_transparent: false,
    opacity: "1",
    is_border: false,
    border: 1,
    border_color: "FF00FF",
    height: [
      {
        screen_type_id: "01",
        height: "0.1",
      },
      {
        screen_type_id: "02",
        height: "0.12",
      },
    ],
    width: [
      {
        screen_type_id: "01",
        width: "1",
      },
    ],
  };
  const footerPosition = blankMargin + sumMargin / 2;

  const detectScreenType = () => {
    const frames = {
      position_type: "absolute",
      frame_count: "96",
      width: [
        {
          screen_type_id: "01",
          value: "1",
        },
        {
          screen_type_id: "02",
          value: "1",
        },
      ],
      height: [
        {
          screen_type_id: "01",
          value: "4",
        },
        {
          screen_type_id: "02",
          value: "5.5",
        },
        {
          screen_type_id: "04",
          value: "4.5",
        },
      ],
      margin: "0.05",
      max_width: "1280",
      max_height: "768",
      header: {
        is_visible: true,
        background_color: "FF0000",
        is_sticky: true,
        is_transparent: false,
        opacity: "1",
        is_border: false,
        border: 1,
        border_color: "FF00FF",
        height: [
          {
            screen_type_id: "01",
            height: "0.2",
          },
          {
            screen_type_id: "02",
            height: "0.3",
          },
        ],
        width: [
          {
            screen_type_id: "01",
            width: "1",
          },
        ],
      },
      footer: {
        is_visible: true,
        background_color: "FF0000",
        is_sticky: false,
        is_transparent: false,
        opacity: "1",
        is_border: false,
        border: 1,
        border_color: "FF00FF",
        height: [
          {
            screen_type_id: "01",
            height: "0.4",
          },
          {
            screen_type_id: "02",
            height: "0.5",
          },
        ],
        width: [
          {
            screen_type_id: "01",
            width: "1",
          },
        ],
      },
      screen_type: [
        {
          screen_type_id: "01",
          screen_type_name: "DESKTOP",
          aspect_ratio_lower_limit: "1",
          minimum_width: "1681",
          is_default: true,
        },
        {
          screen_type_id: "02",
          screen_type_name: "MOBILE",
          aspect_ratio_lower_limit: "0",
          minimum_width: "0",
          is_default: false,
        },
        {
          screen_type_id: "03",
          screen_type_name: "LAPTOP",
          aspect_ratio_lower_limit: "1",
          minimum_width: "1200",
          is_default: false,
        },
        {
          screen_type_id: "04",
          screen_type_name: "TABLET",
          aspect_ratio_lower_limit: "1",
          minimum_width: "0",
          is_default: false,
        },
      ],
      is_frame_direction_vertical: true,
      is_snap_scroll: true,
      snap_scroll_steps: "5",
      snap_scroll_factor: "0.8",
      snap_scroll_wait: "500",
      user_events: [
        {
          type: "wheel",
          key_code: "",
          is_active: true,
          name: "wheel",
          event_type: "scrollY",
          steps: "1",
          is_snap_scroll_active: true,
        },
        {
          type: "keydown",
          key_code: "40",
          is_active: true,
          name: "down arrow",
          event_type: "scrollY",
          steps: "1",
          is_snap_active: false,
        },
        {
          type: "keydown",
          key_code: "38",
          is_active: true,
          name: "up arrow",
          event_type: "scrollY",
          steps: "-1",
          is_snap_active: false,
        },
        {
          type: "keydown",
          key_code: "34",
          is_active: true,
          name: "page down",
          event_type: "scrollY",
          steps: "5",
          is_snap_active: false,
        },
        {
          type: "keydown",
          key_code: "33",
          is_active: true,
          name: "page up",
          event_type: "scrollY",
          steps: "-5",
          is_snap_active: false,
        },
      ],
      ticker: {
        texts: [
          "Photorealistic 3D Interactions",
          "Plug-and-Play Integration",
          "Seamless Web Experience",
        ],
        scroll_speed: 12,
        is_border: true,
        background_color: "#f0f8ff",
        text_color: "#00008b",
        font_size: "1.8rem",
        font_weight: "700",
        font_family: "Arial, sans-serif",
        height: "60px",
        width: "100%",
        border_color: "##00008b",
        border_thickness: "2px",
        is_infinite: true,
        padding_top: "10px",
        padding_bottom: "10px",
        gap: "20px",
        line_height: "1.5",
      },
      cards: {
        containerHeight: "600px",
        containerPadding: "15px",
        containerMargin: "15px",
        borderRadius: "24px",
        hoverEffect: true,
        text_color: "#333",
        sections: [
          {
            id: "showcase",
            title: "Showcase",
            sub_title: "Your Products Unlocked in 3D.",
            background_color: "#ffecec",
            content_type: "image",
            image_url:
              "https://xculptor-img.blr1.digitaloceanspaces.com/USR1000000002/PRJ1000000001/SCR1000000008/card01.png",
            image_width: "300px",
            image_height: "250px",
            image_position: "center",
            image_object_fit: "contain",
            image_padding: "10px",
            image_margin: "0 auto",
            font_family: "Arial, sans-serif",
            font_weight: "bold",
            font_size: "18px",
            line_height: "1.5",
          },
          {
            id: "collections",
            title: "Collections",
            sub_title: "Shape your product, instantly.",
            background_color: "#ffecec",
            content_type: "image",
            image_url:
              "https://xculptor-img.blr1.digitaloceanspaces.com/USR1000000002/PRJ1000000001/SCR1000000008/card02.png",
            image_width: "300px",
            image_height: "250px",
            image_position: "center",
            image_object_fit: "contain",
            image_padding: "10px",
            image_margin: "0 auto",
            font_family: "Arial, sans-serif",
            font_weight: "medium",
            font_size: "16px",
            line_height: "1.4",
          },
          {
            id: "story",
            title: "Story",
            sub_title: "Discover the journey.",
            background_color: "#ecfff2",
            content_type: "image",
            image_url:
              "https://xculptor-img.blr1.digitaloceanspaces.com/USR1000000002/PRJ1000000001/SCR1000000008/card03.png",
            image_width: "300px",
            image_height: "250px",
            image_position: "center",
            image_object_fit: "contain",
            image_padding: "10px",
            image_margin: "0 auto",
            font_family: "Arial, sans-serif",
            font_weight: "normal",
            font_size: "14px",
            line_height: "1.6",
          },
        ],
      },
      templates: [
        {
          template_id: "01",
          template_item: "component",
          type: "container",
          template_name: "banner_text",
          position: [
            {
              screen_type_id: "01",
              top: "0.2",
              left: "0.05",
            },
            {
              screen_type_id: "02",
              top: "0.1",
              left: "0",
            },
          ],
          is_border: [
            {
              screen_type_id: "01",
              value: false,
            },
            {
              screen_type_id: "02",
              value: false,
            },
          ],
          border: [
            {
              screen_type_id: "01",
              value: "2",
            },
            {
              screen_type_id: "02",
              value: "2",
            },
          ],
          border_color: [
            {
              screen_type_id: "01",
              value: "#7f8fbc",
            },
            {
              screen_type_id: "02",
              value: "#7f8fbc",
            },
          ],
          border_radius: [
            {
              screen_type_id: "01",
              value: "3%",
            },
            {
              screen_type_id: "02",
              value: "3%",
            },
          ],
          direction: [
            {
              screen_type_id: "01",
              value: "column",
            },
          ],
          justify_content: [
            {
              screen_type_id: "01",
              value: "flex-start",
            },
            {
              screen_type_id: "02",
              value: "center",
            },
          ],
          align_items: [
            {
              screen_type_id: "01",
              value: "flex-start",
            },
            {
              screen_type_id: "02",
              value: "center",
            },
          ],
          margin_left: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_right: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_top: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_bottom: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          elements: [
            {
              template_id: "02",
            },
            {
              template_id: "03",
            },
          ],
        },
        {
          template_id: "02",
          template_item: "element",
          type: "text",
          template_name: "banner_title",
          visible: [
            {
              screen_type_id: "01",
              value: true,
            },
            {
              screen_type_id: "02",
              value: true,
            },
          ],
          is_border: [
            {
              screen_type_id: "01",
              value: false,
            },
          ],
          is_transparent: [
            {
              screen_type_id: "01",
              value: true,
            },
          ],
          border: [
            {
              screen_type_id: "01",
              value: "1",
            },
          ],
          border_radius: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          border_color: [
            {
              screen_type_id: "01",
              value: "#FF0000",
            },
          ],
          background_color: [
            {
              screen_type_id: "01",
              value: "#EEDD82",
            },
          ],
          text: [
            {
              screen_type_id: "01",
              value: "Website Banner Text",
            },
          ],
          justify_content: [
            {
              screen_type_id: "01",
              value: "left",
            },
            {
              screen_type_id: "02",
              value: "center",
            },
          ],
          text_align: [
            {
              screen_type_id: "01",
              value: "left",
            },
            {
              screen_type_id: "02",
              value: "left",
            },
          ],
          font_family: [
            {
              screen_type_id: "01",
              value: "Outfit",
            },
          ],
          font_size: [
            {
              screen_type_id: "01",
              value: "72",
            },
            {
              screen_type_id: "02",
              value: "40",
            },
          ],
          font_weight: [
            {
              screen_type_id: "01",
              value: "500",
            },
          ],
          font_style: [
            {
              screen_type_id: "01",
              value: "regular",
            },
          ],
          font_color: [
            {
              screen_type_id: "01",
              value: "#192b61",
            },
          ],
          line_height: [
            {
              screen_type_id: "01",
              value: "60px",
            },
            {
              screen_type_id: "02",
              value: "40px",
            },
          ],
          letter_spacing: [
            {
              screen_type_id: "01",
              value: "0.25px",
            },
            {
              screen_type_id: "02",
              value: "-0.5px",
            },
          ],
          margin_left: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_right: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_top: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          margin_bottom: [
            {
              screen_type_id: "01",
              value: "20",
            },
          ],
          padding_left: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          padding_right: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          padding_top: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          padding_bottom: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
        },
        {
          template_id: "03",
          template_item: "element",
          type: "text",
          template_name: "banner_copy",
          visible: [
            {
              screen_type_id: "01",
              value: true,
            },
            {
              screen_type_id: "02",
              value: true,
            },
          ],
          is_border: [
            {
              screen_type_id: "01",
              value: false,
            },
          ],
          is_transparent: [
            {
              screen_type_id: "01",
              value: true,
            },
          ],
          border: [
            {
              screen_type_id: "01",
              value: "1",
            },
          ],
          border_radius: [
            {
              screen_type_id: "01",
              value: "0",
            },
          ],
          border_color: [
            {
              screen_type_id: "01",
              value: "#00FF00",
            },
          ],
          background_color: [
            {
              screen_type_id: "01",
              value: "#EEDD82",
            },
          ],
          text: [
            {
              screen_type_id: "01",
              value: "This is sample text",
            },
          ],
          justify_content: [
            {
              screen_type_id: "01",
              value: "left",
            },
            {
              screen_type_id: "02",
              value: "center",
            },
          ],
          text_align: [
            {
              screen_type_id: "01",
              value: "left",
            },
            {
              screen_type_id: "02",
              value: "left",
            },
          ],
          font_family: [
            {
              screen_type_id: "01",
              value: "Outfit",
            },
          ],
          font_size: [
            {
              screen_type_id: "01",
              value: "24",
            },
            {
              screen_type_id: "02",
              value: "20",
            },
          ],
          font_weight: [
            {
              screen_type_id: "01",
              value: "200",
            },
          ],
          font_style: [
            {
              screen_type_id: "01",
              value: "regular",
            },
          ],
          font_color: [
            {
              screen_type_id: "01",
              value: "#7f8fbc",
            },
          ],
          line_height: [
            {
              screen_type_id: "01",
              value: "30px",
            },
            {
              screen_type_id: "02",
              value: "22px",
            },
          ],
          letter_spacing: [
            {
              screen_type_id: "01",
              value: "-0.25px",
            },
          ],
        },
      ],
    };
    const screen_type = frames?.screen_type;
    const aspectRatio = window.innerWidth / window.innerHeight;
    const screenWidth = window.innerWidth;

    let selectedScreenType = screen_type?.find(
      (screen) => aspectRatio >= parseFloat(screen.aspect_ratio_lower_limit)
    );
    if (!selectedScreenType) {
      selectedScreenType = screen_type?.find((screen) => screen.is_default);
    }

    return {
      selectedScreenTypeId: selectedScreenType?.screen_type_id || "02",
      screenWidthFactor: selectedScreenType
        ? screenWidth / parseFloat(selectedScreenType.standard_width)
        : 1,
    };
  };
  const { selectedScreenTypeId } = detectScreenType();
  const getDimensions = (data, selectedScreenTypeId) => {
    const widthObj = data?.width?.find(
      (w) => w.screen_type_id === selectedScreenTypeId
    );
    const heightObj = data?.height?.find(
      (h) => h.screen_type_id === selectedScreenTypeId
    );

    return {
      width: widthObj ? `${parseFloat(widthObj.width) * 100}vw` : "100vw",
      height: heightObj ? `${parseFloat(heightObj.height) * 100}vh` : "auto",
    };
  };
  const footerDimensions = getDimensions(footerData, selectedScreenTypeId);
  const HeaderDimensions = getDimensions(headerData, selectedScreenTypeId);
  console.log("HeaderDimensions", HeaderDimensions);
  const currentSectionPositions = [];

  return (
    <>
      <div
        style={{
          position: headerData.is_sticky ? "sticky" : "relative",
          // zIndex: 5000000,
        }}
      >
        <Header
          headerData={headerData}
          HeaderDimensions={HeaderDimensions}
          pageWidthCalc={pageWidthCalc}
          headerPosition={headerPosition}
          sectionPositions={currentSectionPositions}
        />
      </div>
      <Box
        style={{
          paddingTop: `calc(${HeaderDimensions?.height} + 1vh)`,
        }}
      >
        {children}
      </Box>

      <Footer
        footerDimensions={footerDimensions}
        pageWidthCalc={pageWidthCalc}
        footerPosition={footerPosition}
      />
    </>
  );
};

export default HeaderFooterWrapper;
